import './index.scss'
$("#nav7").addClass("active");
$(".drop").click(function () {
    $(this).parent().parent().find("div").slideToggle();
    $(this).parent().toggleClass('active');
})